module.exports = __webpack_public_path__ + "img/portfolio-3.2b4c7bde.jpg";